import { gql, NetworkStatus, useQuery } from "@apollo/client";
import { shiftStreamClient } from "../../../graphql/client";

export const GET_EMAIL = gql`
  query getEmail($id: Int!) {
    email(id: $id) {
      id
      mailboxAddress
      sender
      receivedAt
      subject
      state
      responseMessage
      errorMessage
      scrapeReasons
      expiresAt
      isExpiredManually
      stopped
      preview
      dashboardUrl
      metadata

      parsed {
        client
        clientName
        site
        siteName
        role
        roleName
        date
        start
        end
        number
        isPartial
      }

      replies {
        id
        template
        sentAt
        preview
      }

      streams {
        id
        accountId
        state
        shiftId
        key
        noAlgo
        slots

        account {
          id
          provider
          name
        }

        shift {
          id
          startTime
          endTime
          sourceAccount {
            id
            accountName
          }
          role {
            id
            name
          }
          venue {
            id
            name
          }
          subvenue {
            id
            name
          }
        }
      }
    }
  }
`;

export const useEmail = (id: number | null) => {
  const { data, loading, networkStatus, refetch } = useQuery(GET_EMAIL, {
    client: shiftStreamClient,
    variables: {
      id,
    },
    fetchPolicy: "cache-and-network",
    notifyOnNetworkStatusChange: true,
    onError: (error) => {
      throw error;
    },
  });

  return {
    loading: loading || networkStatus === NetworkStatus.refetch,
    email: data?.email || null,
    refetch,
  };
};
